import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotFaceGrin = ({ spotColor = "#1AD3B2", color = "#13126C", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" {...props}>
        <defs>
            <path id="face_aqua_slight_smile_svg__a" d="M0 0h37v37H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="face_aqua_slight_smile_svg__b" fill="#fff">
                <use xlinkHref="#face_aqua_slight_smile_svg__a" />
            </mask>
            <path
                fill={spotColor}
                d="M1 18.5C1 28.15 8.85 36 18.5 36S36 28.15 36 18.5 28.15 1 18.5 1 1 8.85 1 18.5Z"
                mask="url(#face_aqua_slight_smile_svg__b)"
                opacity={0.25}
            />
            <path
                fill={color}
                d="M18.5 0C28.7 0 37 8.3 37 18.5S28.701 37 18.5 37 0 28.7 0 18.5 8.299 0 18.5 0Zm0 1.516C9.135 1.516 1.516 9.135 1.516 18.5c0 9.365 7.619 16.984 16.984 16.984 9.365 0 16.984-7.619 16.984-16.984 0-9.365-7.619-16.984-16.984-16.984Zm-8.048 21.006.131.007a.8.8 0 0 1 .536.307 9.42 9.42 0 0 0 7.487 3.67 9.444 9.444 0 0 0 7.263-3.394.81.81 0 0 1 1.137-.102.809.809 0 0 1 .102 1.138 11.057 11.057 0 0 1-8.502 3.974 11.02 11.02 0 0 1-8.762-4.296.806.806 0 0 1 .143-1.133.786.786 0 0 1 .596-.164Zm2.005-12.308c.794 0 1.636.575 1.636 1.64 0 1.063-.842 1.636-1.636 1.636-.419 0-.814-.145-1.112-.41-.339-.302-.525-.737-.525-1.226 0-1.065.843-1.64 1.637-1.64Zm12.29 0c.794 0 1.64.575 1.64 1.64 0 1.063-.846 1.636-1.64 1.636-.42 0-.813-.145-1.112-.41-.34-.301-.526-.736-.526-1.226 0-1.065.843-1.64 1.638-1.64Zm-12.29 1.263c-.14 0-.374.05-.374.377 0 .325.234.373.374.373.14 0 .373-.048.373-.373 0-.129-.034-.224-.103-.284a.41.41 0 0 0-.27-.093Zm12.29 0c-.14 0-.375.05-.375.377 0 .325.234.373.375.373.14 0 .375-.048.375-.373 0-.13-.033-.223-.103-.284a.413.413 0 0 0-.272-.093Z"
                mask="url(#face_aqua_slight_smile_svg__b)"
            />
        </g>
    </SVG>
);

SpotFaceGrin.displayName = "SpotFaceGrin";
